<script setup>
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'

const router = useRouter()
const route  = useRoute()

onMounted(() => {
  const unsubscribe = Hub.listen('auth', async ({ payload }) => {
    if (payload.event === 'signInWithRedirect') {
      unsubscribe()
      const { tokens } = await fetchAuthSession({ forceRefresh: true })
      if (!tokens?.idToken) return router.replace({ name: 'SignIn' })
      router.replace(route.query.redirect || '/admin')
    }
    if (payload.event === 'signInWithRedirect_failure') {
      unsubscribe()
      console.warn('[auth-callback] failure', payload)
      router.replace({ name: 'SignIn' })
    }
  })
})
</script>

<template>
  <div style="padding:2rem; text-align:center">
    Signing you in…
  </div>
</template>
